import { Collapse, CollapseProps, Flex } from 'antd/lib'
import classes from './ModelFeedback.module.less'
import { useMemo } from 'react'
import { MarkdownViewer } from '../MarkdownViewer/MarkdownViewer'
import { TransformedModelFeedback } from 'Types/CustomTask.types'

type ModelFeedbackPropsType = {
    feedbacks: TransformedModelFeedback[]
}

export const ModelFeedback = (props: ModelFeedbackPropsType) => {
    const transformedModelFeedbackItems: CollapseProps['items'] = useMemo(
        () =>
            props.feedbacks.map((feedback, index) => ({
                label: `${index + 1}. ${feedback.feedback_result_code_label}`,
                key: index,
                children: <MarkdownViewer text={feedback.feedback_message} title={''} />,
            })),
        [props.feedbacks]
    )

    if (!transformedModelFeedbackItems.length) return null

    return (
        <Flex vertical gap={10}>
            <div className={classes.title}>Feedback on Model Response</div>
            <Collapse items={transformedModelFeedbackItems} />
        </Flex>
    )
}
